<template>
  <div class="controller-section" tabindex="0" @keydown.enter="toggleExpand">
    <div class="section-title" v-b-toggle="title">{{ title }}</div>
    <b-collapse v-model="visible" :id="title">
      <div class="section">
        <slot></slot>
      </div>
    </b-collapse>
  </div>
</template>
<script>

export default {
  name: 'ControllerSection',
  props: {
    title: { type: String, required: true },
    startVisible: { type: Boolean, required: false, default: false },
  },
  data() {
    return { visible: this.startVisible };
  },
  methods: {
    toggleExpand() {
      this.visible = !this.visible;
    },
  },
};

</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.controller-section {
  margin-bottom: 15px;
  .section-title {
    padding: 10px;
    background-color: $riseup_blue;
    color: white;
    font-weight: bold;
    border: solid 1px $riseup_light_blue;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    &:not(.collapsed) {
      border-radius: 4px 4px 0 0;
      border-bottom: solid 0;
    }
    &:not(:first-of-type) {
      margin-top: 10px;
    }
  }
  .section {
    border: solid 1px $riseup_gray_0;
    border-top: solid 0px;
    border-radius: 0 0 4px 4px;
    padding: 20px 15px;
  }
}
</style>
